import { Markdown } from '../Markdown'

/** Dispatcher's crew addendum at the bottom of the hero card, unlabeled like v1.
 * The block is the positioning context for the API's absolutely placed
 * buttons (CMP "View Permits" sits at its top, like v1's IonCol). */
export const AddendumBlock = ({ markdown }: { markdown: string }) => (
  <div className='assignment-detail__hero-block assignment-detail__hero-block--addendum'>
    <div className='assignment-detail__section-body assignment-detail__markdown'>
      <Markdown>{markdown}</Markdown>
    </div>
  </div>
)
